/**
 * 猪猪币接口
 */

import { apiProxy } from '../util-lib/http';
import { ensureParams } from '../util-lib/api-proxy';

// 获取兑换商品列表
export async function getGoodsList() {
  const api = 'api/v1.0/Poi/Zhuzhubi/ActivityGoodsList';
  const body = await apiProxy.get(api);
  return body.activityGoodsList.data;
}

export async function exchangeGoods(params = {}) {
  params = ensureParams(params, exchangeGoods.__definedParams);
  const api = 'api/v1.0/Poi/Zhuzhubi/ExchangeActivityGoods';
  const body = await apiProxy.post(api, params);
  return body.exchangeActivityGoods.data;
}

exchangeGoods.__definedParams = {
  id: '',
  phone: ''
};
